import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Cos'è la mediazione familiare",
    subtitle: "Un percorso neutro e protetto",
    desc: "Un percorso strutturato in cui una terza persona qualificata e imparziale — il mediatore familiare — aiuta i genitori a riorganizzare le relazioni familiari prima, durante o dopo la separazione. Non è terapia e non è un processo: è uno spazio dove tornare a decidere insieme.",
  },
  {
    num: "02",
    title: "A chi serve",
    subtitle: "Per ogni fase della vita familiare",
    desc: "Coppie che stanno valutando la separazione, genitori già separati che faticano a comunicare, famiglie che devono rivedere accordi su figli, tempi e spese. Serve a chi vuole tutelare il benessere dei propri figli prima di ogni altra cosa.",
  },
  {
    num: "03",
    title: "Come funziona",
    subtitle: "Incontri brevi, riservati, volontari",
    desc: "Si inizia con un colloquio informativo, poi un ciclo di 8–12 incontri coperti dal segreto professionale, lontano dalle aule di tribunale. L'obiettivo: un accordo genitoriale concreto, duraturo e condiviso da entrambi.",
  },
];

export const ManifestoChapters = () => (
  <section id="manifesto" data-testid="manifesto-chapters" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-14 lg:mb-20">
        <Reveal className="lg:col-span-5">
          <p className="overline-tag mb-4">Il manifesto</p>
          <h2 className="font-serif font-semibold text-ink tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Tre cose da sapere, prima di tutto il resto.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-7 lg:pt-12">
          <p className="text-base sm:text-lg leading-relaxed text-mist max-w-2xl">
            La mediazione familiare è riconosciuta in Italia dalla Legge 54/2006 e valorizzata dalla
            Riforma Cartabia come strumento per ridurre la conflittualità. A Crotone, molte famiglie
            non sanno che esiste un'alternativa alla guerra legale: questa pagina nasce per spiegarla.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.15} data-testid={`manifesto-chapter-${c.num}`}>
            <article
              data-testid={`manifesto-chapter-${c.num}`}
              className="group h-full bg-white border border-ink/10 rounded-2xl p-8 lg:p-10 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_24px_50px_-30px_rgba(20,41,46,0.35)] transition-all duration-500"
            >
              <span className="font-serif text-6xl lg:text-7xl font-semibold text-gold/70 group-hover:text-golddeep transition-colors duration-500">{c.num}</span>
              <h3 className="mt-6 font-serif font-semibold text-ink text-xl sm:text-2xl leading-snug">{c.title}</h3>
              <p className="mt-1 font-display text-xs uppercase tracking-[0.18em] text-golddeep font-semibold">{c.subtitle}</p>
              <p className="mt-5 text-sm sm:text-base leading-relaxed text-mist">{c.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
